import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";
import createBirthDoc from './modules/CreateDoc';
import Auth from './modules/Auth';

// Create store
export default new Vuex.Store({
  modules: {
    createBirthDoc,
    Auth
  },
  plugins: [createPersistedState()]
});